export default __webpack_public_path__ + "static/media/oscer-pres-hand-pain.683969ae.svg";